export default (ctx) => ({
  login(email, password) {
    const { $auth } = ctx
    return $auth.loginWith('local', { data: { api_user: { email, password } } })
  },

  logout() {
    const { $auth } = ctx
    return $auth.logout()
  }
})
